/*
 * 4AL 2.0: Verhalten der Produktseiten-Bausteine (snippets/al-*.liquid).
 * - Groessentabelle oeffnen/schliessen und Rechner "Miss dein Lieblingsteil"
 * - Lieferdatum aus Werktagen ausrechnen (Sa/So zaehlen nicht, Feiertage sind nicht beruecksichtigt)
 * - Drei echte Kundenfotos als Gesichter im Social Proof
 * - "Gibt's auch als": dasselbe Motiv auf anderen Produkten
 */
(() => {
  if (window.alProdukt) return;
  window.alProdukt = true;

  document.addEventListener('click', (event) => {
    const oeffnen = event.target.closest('[data-al-oeffnen]');

    if (oeffnen) {
      document.getElementById(oeffnen.dataset.alOeffnen)?.showModal();
      return;
    }

    // Klick auf den Schliessen-Button oder auf den Hintergrund ausserhalb des Inhalts
    if (event.target.closest('[data-al-schliessen]') || event.target.matches('dialog.al-dialog')) {
      event.target.closest('dialog')?.close();
    }
  });

  document.addEventListener('input', (event) => {
    const feld = event.target.closest('[data-al-breite]');
    if (!feld) return;

    const dialog = feld.closest('dialog');
    const zeilen = [...dialog.querySelectorAll('tr[data-breite]')];
    const ergebnis = dialog.querySelector('[data-al-ergebnis]');
    const breite = parseFloat(feld.value.replace(',', '.'));

    zeilen.forEach((zeile) => zeile.classList.remove('is-empfohlen'));

    if (!breite || zeilen.length === 0) {
      ergebnis.textContent = '';
      return;
    }

    // Kleinste Groesse, die mindestens so breit ist wie das Lieblingsteil
    const passend = zeilen.find((zeile) => parseFloat(zeile.dataset.breite) >= breite);
    const zeile = passend || zeilen[zeilen.length - 1];

    zeile.classList.add('is-empfohlen');
    ergebnis.textContent = passend
      ? `Unsere Empfehlung: ${zeile.cells[0].textContent}`
      : `Am weitesten ist ${zeile.cells[0].textContent}`;
  });

  const plusWerktage = (datum, tage) => {
    const ergebnis = new Date(datum);
    let uebrig = tage;

    while (uebrig > 0) {
      ergebnis.setDate(ergebnis.getDate() + 1);
      const tag = ergebnis.getDay();
      if (tag !== 0 && tag !== 6) uebrig -= 1;
    }

    return ergebnis;
  };

  const mitTag = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
  const kurz = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit' });

  const lieferdaten = () => {
    document.querySelectorAll('[data-al-lieferung]').forEach((box) => {
      const heute = new Date();
      const von = plusWerktage(heute, Number(box.dataset.min));
      const bis = plusWerktage(heute, Number(box.dataset.max));

      const heuteFeld = box.querySelector('[data-al-heute]');
      if (heuteFeld) heuteFeld.textContent = mitTag.format(heute);
      box.querySelector('[data-al-zeitraum]').textContent = `${kurz.format(von)} – ${kurz.format(bis)}`;
    });
  };

  // Echte Kundenfotos aus dem Foto-Karussell der Bewertungen als kleine Gesichter im Social Proof
  const avatare = () => {
    const ziel = document.querySelector('[data-al-avatare]');
    const karussell = document.querySelector('[data-ms-reviews="foto-karussell"]');
    if (!ziel || !karussell) return;

    const fuellen = () => {
      const bilder = [...karussell.querySelectorAll('img')].map((bild) => bild.currentSrc || bild.src).filter(Boolean).slice(0, 3);
      if (bilder.length < 3) return false;

      ziel.replaceChildren(...bilder.map((src) => Object.assign(document.createElement('img'), { src, alt: '', width: 36, height: 36 })));
      ziel.hidden = false;
      return true;
    };

    if (fuellen()) return;

    const beobachter = new MutationObserver(() => {
      if (fuellen()) beobachter.disconnect();
    });
    beobachter.observe(karussell, { childList: true, subtree: true });
  };

  // Titel am letzten " - " in Motiv und Zusatz teilen, dieselbe Regel wie snippets/al-titel.liquid
  const titelTeile = (titel) => {
    const teile = titel.replaceAll(' – ', ' - ').replaceAll('- ', ' - ').split(' - ');
    if (teile.length < 2) return { motiv: titel.trim(), zusatz: '' };

    const motiv = teile.slice(0, -1).map((teil) => teil.trim()).join(' - ').trim();
    let zusatz = teile[teile.length - 1].replaceAll('*', '').replace(/back ?print/gi, 'Rückendruck').trim();
    let druck = '';

    if (zusatz.includes('Rückendruck')) {
      druck = 'Rückendruck';
      zusatz = zusatz.replaceAll('Rückendruck', '');
    } else if (zusatz.includes('Bauchtaschendruck')) {
      druck = 'Bauchtaschendruck';
      zusatz = zusatz.replaceAll('Bauchtaschendruck', '');
    } else if (zusatz.includes('Brustdruck')) {
      druck = 'Brustdruck';
      zusatz = zusatz.replaceAll('Brustdruck', '');
    } else if (zusatz.includes(' Brust')) {
      druck = 'Brustdruck';
      zusatz = zusatz.replaceAll(' Brust', '');
    }

    zusatz = zusatz.replaceAll('  ', ' ').trim();
    if (druck) zusatz = zusatz ? `${zusatz} · ${druck}` : druck;

    return motiv ? { motiv, zusatz } : { motiv: titel.trim(), zusatz: '' };
  };

  const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  // "Gibt's auch als": Produkte mit demselben Motiv ueber die Shopify-Suche (nur ohne Auswahl in custom.gibts_auch_als)
  const auchAls = async () => {
    const box = document.querySelector('[data-al-auch-als]');
    if (!box) return;

    const { motiv, handle } = box.dataset;
    const adresse = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(motiv)}`
      + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title';

    try {
      const antwort = await fetch(adresse);
      if (!antwort.ok) return;

      const daten = await antwort.json();
      const gesehen = new Set();
      const treffer = (daten.resources?.results?.products || []).filter((produkt) => {
        const teile = titelTeile(produkt.title);
        const passt = produkt.handle !== handle && produkt.available
          && teile.motiv.toLowerCase() === motiv.toLowerCase() && !gesehen.has(teile.zusatz);

        if (passt) gesehen.add(teile.zusatz);
        return passt;
      }).slice(0, 4);

      if (treffer.length === 0) return;

      // Preise zeigt die Suche in der Shop-Waehrung, deshalb nur bei Euro
      const mitPreis = (window.Shopify?.currency?.active || 'EUR') === 'EUR';
      const liste = box.querySelector('[data-al-auch-als-liste]');

      liste.replaceChildren(...treffer.map((produkt) => {
        const link = Object.assign(document.createElement('a'), { className: 'al-auch-als__produkt', href: produkt.url });
        const bild = produkt.featured_image?.url || produkt.image;

        if (bild) {
          // Das Shopify-CDN liefert das Bild klein aus (die Suche gibt die Originalgroesse zurueck)
          const klein = new URL(bild, window.location.href);
          klein.searchParams.set('width', '160');
          link.append(Object.assign(document.createElement('img'), { src: klein.href, alt: '', width: 64, height: 64, loading: 'lazy' }));
        }

        link.append(Object.assign(document.createElement('span'), {
          className: 'al-auch-als__name',
          textContent: titelTeile(produkt.title).zusatz || produkt.title,
        }));

        if (mitPreis) {
          const ab = produkt.price_min !== produkt.price_max ? 'ab ' : '';
          link.append(Object.assign(document.createElement('span'), {
            className: 'al-auch-als__preis',
            textContent: `${ab}${euro.format(Number(produkt.price_min || produkt.price))}`,
          }));
        }

        return link;
      }));

      box.hidden = false;
    } catch (fehler) {
      // Ohne Antwort der Suche bleibt der Block einfach verborgen
    }
  };

  // Links zur Groessentabelle ohne passendes Fenster ausblenden (Baustein im Editor aus oder keine Groesse passt)
  const groessenLinks = () => {
    document.querySelectorAll('[data-al-oeffnen]').forEach((knopf) => {
      if (!document.getElementById(knopf.dataset.alOeffnen)) knopf.hidden = true;
    });
  };

  const start = () => {
    groessenLinks();
    lieferdaten();
    avatare();
    auchAls();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
